import { useEffect } from "react";

export function useOutsideAlerter(ref: any, callBack: (arg: boolean) => void) {
  useEffect(() => {
    /**
     * Alert if clicked or focus on outside of element
     */
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        callBack(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callBack, ref]);
}
